import React from 'react'
import { sharedData } from '../../../models/shared_data'

const STORAGE_KEY = 'cookieConsentDismissedAt'

export class CookieConsentBanner extends React.Component {
  constructor(props) {
    super(props)
    let dismissed = false
    try {
      dismissed = localStorage.getItem(STORAGE_KEY) != null
    } catch (e) {}
    this.state = { dismissed }
    sharedData.subject.subscribe(()=> { this.forceUpdate() })
    this.dismiss = this.dismiss.bind(this)
  }

  dismiss() {
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())) } catch (e) {}
    this.setState({ dismissed: true })
  }

  render() {
    if (this.state.dismissed) return null
    const sp = (sharedData.data && sharedData.data.site_params) || {}
    if (!sp.cookie_widget_enabled) return null
    const text = sp.cookie_widget_text || ''
    const btnText = sp.cookie_widget_button_text || 'Согласен'
    const links = sp.cookie_widget_links || []
    return (
      <div className="cookie-consent">
        <div className="cookie-consent__inner">
          <div className="cookie-consent__text">{text}</div>
          { links.length > 0 &&
            <div className="cookie-consent__links">
              { links.map((l, i)=> (
                <a key={i} href={l.url} target="_blank" rel="noopener noreferrer" className="cookie-consent__link">{l.title}</a>
              )) }
            </div>
          }
          <button type="button" className="btn btn--red cookie-consent__btn" onClick={this.dismiss}>{btnText}</button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/shared/cookie_consent/cookie_consent.component.jsx